import script from "./VolPayNoticeFold.vue?vue&type=script&setup=true&lang=js"
export * from "./VolPayNoticeFold.vue?vue&type=script&setup=true&lang=js"

import "./VolPayNoticeFold.vue?vue&type=style&index=0&id=0975fa4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0975fa4e"]])

export default __exports__